import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import Request from "../based/Request";
import { Notify } from "../based/Notify";
import { NOTIFY, PLATFORM, PLATFORM_NAME } from "../based/Constants";
import TFUSelect from "../based/refactor/TFUSelect";
import PushingServices from "../based/services/PushingServices";
import Common from "../based/Common";
export const PushingPhotoshopProduct = {
    id: 0,
    photoshopFileId: 0,
    appProductId: 0,
    appProductName: "",
    appProductAvatar: "",
    pushingPhotoshopVariants: [],
};

const FileType = {
    Normal: 0,
    Case: 1,
};

export const PushingPhotoshopFile = {
    id: 0,
    name: "",
    fileUrl: "",
    thumbnail: "",
    fileProducts: [PushingPhotoshopProduct],
    appProductId: 0,
    appProductName: "",
    photoshopFileType: PLATFORM.Internal,
    colorCode: "",
    photoshopFileTypeName: [],
    note: "",
    fileType: 0,
    artworkCount: 1,
    sex: 0,
};

const PhotoshopFileList = [
    {
        value: PLATFORM.Internal,
        text: PLATFORM_NAME.Internal,
    },
    {
        value: PLATFORM.Shopee,
        text: PLATFORM_NAME.Shopee,
    },
    {
        value: PLATFORM.Lazada,
        text: PLATFORM_NAME.Lazada,
    },
    {
        value: PLATFORM.Tiktok,
        text: PLATFORM_NAME.Tiktok,
    },
    {
        value: PLATFORM.Facebook,
        text: PLATFORM_NAME.Facebook,
    },
    {
        value: PLATFORM.Zalo,
        text: PLATFORM_NAME.Zalo,
    },
];

function PartnerPhotoshopFileModal({ id, isShowModal, onClose, onSave, partnerId }) {
    const [isBusy, setIsBusy] = useState(false);
    const [model, setModel] = useState(PushingPhotoshopFile);
    const [productOptions, setProductOptions] = useState([]); // [ { value: 1, label: "Product 1" }
    const [productIds, setProductIds] = useState([]);
    const [colors, setColors] = useState([]);
    const [isBusyUpload, setIsBusyUpload] = useState(false);
    const [hoverValue, setHoverValue] = useState(null);

    useEffect(() => {
        getColor();
        getProductOptions().then(() => {
            if (id > 0) {
                getById(id);
            } else {
                setModel(PushingPhotoshopFile);
            }
        });
    }, [isShowModal]);

    const getById = async (id) => {
        setIsBusy(true);
        let [err, data] = await PushingServices.GetPhotoshopFileById(id);
        if (!err && data) {
            setModel(data);

            //config thông tin sản phẩm
            if (data.fileProducts) {
                let ids = data.fileProducts.reduce((prev, item, idx) => {
                    if (prev.includes(item.appProductId)) return prev;
                    return [...prev, item.appProductId];
                }, []);
                setProductIds(ids);
            }

            //config thông tin ignore product
            if (data.pushingPhotoshopFileIgnores && data.pushingPhotoshopFileIgnores.length > 0) {
                let ignorePool = data.pushingPhotoshopFileIgnores;

                let newProductOptions = productOptions.map((item) => {
                    let ignoreProductIds = ignorePool.filter((x) => x.templateAppProductId == item.value).map((x) => x.ignoreAppProductId);
                    return { ...item, ignoreProductIds };
                });
                setProductOptions(newProductOptions);
            }
        }
        setIsBusy(false);
    };

    const _handleSave = async () => {
        setIsBusy(true);
        let md = { ...model, fileProducts: productIds.map((item) => ({ appProductId: item })), partnerId: +partnerId };
        let [err, data] = await PushingServices.CreateOrUpdatePhotoshopFile(md);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
            onSave();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
        }
        setIsBusy(false);
    };

    const handleUploadFile = (e) => {
        e.preventDefault();

        return new Promise((resolve, reject) => {
            let file = e.target.files[0];
            if (!file) return;
            setIsBusyUpload(true);

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                Request.UploadPhotoshop(file).then((res) => {
                    if (res && res.data) {
                        const { fileUrl, fileName } = res.data;
                        // setModel({ ...model, fileUrl, name: fileName });
                        resolve(res.data);
                        Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Upload PSD thành công");
                    } else {
                        Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
                        reject();
                    }
                    setIsBusyUpload(false);
                });
            };
        });
    };

    const handleUploadThumbnail = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (!file) return;
        setIsBusy(true);
        Request.UploadImage(file).then((res) => {
            if (res && res.data) {
                const { imageUrl } = res.data;
                setModel({ ...model, thumbnail: imageUrl });
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Upload thumbnail thành công");
            } else {
                Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
            }
        });

        setIsBusy(false);
    };

    const getProductOptions = async () => {
        let [err, data] = await PushingServices.GetDropdownProduct();
        if (!err && data) {
            setProductOptions(data);
        } else {
            setProductOptions([]);
        }
    };

    const getColor = async () => {
        let [err, data] = await PushingServices.GetColorValue();
        if (!err && data) {
            setColors(data);
        } else {
            setColors([]);
        }
    };

    const handleUploadMultipleImage = (e) => {
        e.preventDefault();
        let files = e.target.files;
        if (!files || files.length == 0) return;
        setIsBusy(true);
        let formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append("file", files[i]);
        }

        Request.UploadMultipleImage(files).then((res) => {
            if (res && res.data) {
                const { listImageUrl } = res.data;

                let md = { ...model };
                let pushingPhotoshopImages = md.pushingPhotoshopImages || [];
                listImageUrl.forEach((item) => {
                    pushingPhotoshopImages.push({ imageUrl: item });
                });
                md.pushingPhotoshopImages = pushingPhotoshopImages;
                setModel(md);
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Upload thumbnail thành công");
            } else {
                Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
            }
            setIsBusy(false);
        });
    };

    return (
        <CommonModal show={isShowModal} size="lg" isBusy={isBusy} busyMsg={"Đang tải dữ liệu"} title={id > 0 ? "Cập nhật File PSD" : "Upload File PSD"} onSave={_handleSave} onClose={() => onClose()}>
            <Wrapper>
                <div className="row my-2">
                    <div className="col-md-12">
                        <div className="form-group form-row">
                            <label htmlFor="" className="required">
                                Loại sản phẩm
                            </label>
                            <div className="list-file-type ml-3">
                                <div
                                    className="file-type"
                                    onClick={(e) => {
                                        setModel({ ...model, fileType: FileType.Normal });
                                    }}
                                >
                                    <input type="checkbox" checked={model.fileType == FileType.Normal} onChange={(e) => {}} />
                                    <span>Áo thun/ Túi tote/ Bình nước/ Hộp bút</span>
                                </div>
                                <div
                                    className="file-type my-3"
                                    onClick={(e) => {
                                        setModel({ ...model, fileType: FileType.Case });
                                    }}
                                >
                                    <input type="checkbox" checked={model.fileType == FileType.Case} onChange={(e) => {}} />
                                    <span>Ốp lưng</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group form-row">
                            <label htmlFor="fileUrl" className="required mb-1">
                                File render hình
                            </label>
                            <div className="sub-instruction col-md-12 mb-2 pl-0">Định dạng PSD</div>
                            <div
                                className="input-square cursor-pointer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (!isBusyUpload) document.getElementById("fileUrl").click();
                                }}
                            >
                                {isBusyUpload ? <span className="text text-warning">Đang tải dữ liệu</span> : <span className="btn btn-secondary">Chọn file</span>}
                            </div>
                            <input
                                type="file"
                                className="col-md-12 pl-0 d-none"
                                name="fileUrl"
                                id="fileUrl"
                                placeholder="Chọn file"
                                onChange={(e) => {
                                    handleUploadFile(e).then((res) => {
                                        if (res) {
                                            setModel({ ...model, fileUrl: res.fileUrl, name: res.fileName });
                                        }
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group form-row">
                            <label htmlFor="thumbnail" className="required mb-1">
                                Hình mô tả
                            </label>
                            <div className="sub-instruction col-md-12 mb-2 pl-0">Định dạng JPG hoặc PNG</div>
                            <div
                                className="input-square cursor-pointer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    document.getElementById("thumbnail").click();
                                }}
                            >
                                {model.thumbnail ? <div className="thumbnail-avatar">{<img src={model.thumbnail} />}</div> : <span className="upload-thumbnail">Chọn file</span>}
                            </div>
                            <input
                                type="file"
                                className="col-md-12 pl-0 d-none"
                                name="thumbnail"
                                id="thumbnail"
                                placeholder="Hình mô tả"
                                onChange={(e) => {
                                    handleUploadThumbnail(e);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="row my-2">
                    <div className="form-group form-row col-md-12">
                        <label htmlFor="" className="required">
                            Hình trong file
                        </label>
                        <div className="list-upload-image">
                            {model.pushingPhotoshopImages &&
                                model.pushingPhotoshopImages.map((item, idx) => {
                                    return (
                                        <div className="input-thumbnail-item" onMouseEnter={() => setHoverValue(item.imageUrl)} onMouseLeave={() => setHoverValue(null)} key={idx}>
                                            <img src={item.imageUrl} />
                                            {hoverValue == item.imageUrl && (
                                                <div className="hover-icon">
                                                    <div
                                                        className="remove-btn cursor-pointer"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            let newList = model.pushingPhotoshopImages.filter((x) => x.imageUrl != item.imageUrl);
                                                            setModel({ ...model, pushingPhotoshopImages: newList });
                                                        }}
                                                    >
                                                        <i className="fa fa-lg fi-trash"></i>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            <div
                                className="upload-pts-img cursor-pointer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    document.getElementById("upload-pts-img").click();
                                }}
                            >
                                <div className="icon-up">
                                    <i className="fa fa-plus"></i>
                                    <span>Chọn file</span>
                                </div>
                            </div>
                            <input
                                type="file"
                                className="d-none"
                                onChange={(e) => {
                                    handleUploadMultipleImage(e);
                                }}
                                multiple
                                id="upload-pts-img"
                                accept="image/*"
                            />
                        </div>
                    </div>
                </div>
                <div className="row my-2">
                    <div className="form-group form-row col-md-12">
                        <label htmlFor="fileUrl" className="required">
                            Đường dẫn Url
                        </label>
                        <input type="text" className="form-control" name="fileUrl" id="fileUrl" placeholder="Đường dẫn Url" value={model.fileUrl} readOnly />
                    </div>
                    <div className="form-group form-row col-md-12">
                        <label htmlFor="name" className="required">
                            Tên file
                        </label>
                        <input type="text" className="form-control" name="name" id="name" placeholder="Tên file" value={model.name} onChange={(e) => setModel({ ...model, name: e.target.value })} />
                    </div>
                </div>
                <div className="row my-2">
                    <div className="form-group form-row col-md-6">
                        <label htmlFor="sex" className="required col-md-12">
                            Giới tính
                        </label>
                        {/* Tạo 2 radio box cho 1 mặt và 2 mặt */}
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="sex1" id="sex1" value="0" checked={model.sex == 0} onChange={(e) => setModel({ ...model, sex: 0 })} />
                            <label className="form-check-label" htmlFor="sex1">
                                Nam
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="sex2" id="sex2" value="1" checked={model.sex == 1} onChange={(e) => setModel({ ...model, sex: 1 })} />
                            <label className="form-check-label" htmlFor="sex2">
                                Nữ
                            </label>
                        </div>
                    </div>
                    <div className="form-group form-row col-md-6">
                        <label htmlFor="artworkCount" className="required col-md-12">
                            Số mặt
                        </label>
                        {/* Tạo 2 radio box cho 1 mặt và 2 mặt */}
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="artworkCount" id="artworkCount1" value="1" checked={model.artworkCount == 1} onChange={(e) => setModel({ ...model, artworkCount: 1 })} />
                            <label className="form-check-label" htmlFor="artworkCount1">
                                1 mặt
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="artworkCount" id="artworkCount2" value="2" checked={model.artworkCount == 2} onChange={(e) => setModel({ ...model, artworkCount: 2 })} />
                            <label className="form-check-label" htmlFor="artworkCount2">
                                2 mặt
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row my-2">
                    <div className="form-group form-row col-md-12">
                        <label htmlFor="" className="required col-md-12">
                            Sàn áp dụng
                        </label>
                        {PhotoshopFileList.map((item, index) => {
                            return (
                                <div key={index} className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="photoshopFileType"
                                        id={item.value}
                                        value={item.value}
                                        checked={Common.hasFlag(model.photoshopFileType, +item.value)}
                                        onChange={(e) => {
                                            //bitwise operator check
                                            let md = { ...model };
                                            let ptsFile = md.photoshopFileType;
                                            if (Common.hasFlag(ptsFile, +e.target.value)) {
                                                //remove flag
                                                ptsFile = ptsFile ^ +e.target.value;
                                            } else {
                                                //add flag
                                                ptsFile = ptsFile | +e.target.value;
                                            }
                                            setModel({ ...model, photoshopFileType: ptsFile });
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor={item.value}>
                                        {item.text}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {model.fileType == FileType.Normal && (
                    <React.Fragment>
                        <div className="row my-2">
                            <div className="form-group form-row col-md-6">
                                <label className="col-md-12" htmlFor="colorCode">
                                    Màu sản phẩm
                                </label>
                                <TFUSelect name="colorCode" className="col-md-12" id="colorCode" value={model.colorCode} options={colors} onChanged={(value) => setModel({ ...model, colorCode: value })} />
                            </div>
                        </div>
                        <div className="row my-2">
                            <div className="form-group form-row col-md-12">
                                <label htmlFor="fileProducts" className="required">
                                    Dòng sản phẩm có trong file
                                </label>
                                <div className="card-box">
                                    {productOptions &&
                                        productOptions.length &&
                                        productOptions.map((item, index) => {
                                            return (
                                                <div
                                                    className="card-item cursor-pointer"
                                                    key={index}
                                                    onClick={() => {
                                                        let index = productIds.indexOf(+item.value);
                                                        if (index >= 0) {
                                                            productIds.splice(index, 1);
                                                        } else {
                                                            productIds.push(+item.value);
                                                        }
                                                        setProductIds([...productIds]);
                                                    }}
                                                >
                                                    <div className="check-item">
                                                        <input type="checkbox" value={productIds.includes(+item.value)} checked={productIds.includes(+item.value)} />
                                                    </div>
                                                    <div className="check-content">
                                                        <label>{item.label}</label>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </Wrapper>
        </CommonModal>
    );
}

export default PartnerPhotoshopFileModal;

const Wrapper = styled.div`
    .hover-icon {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.6);
    }

    .input-thumbnail-item {
        position: relative;
    }
    .list-upload-image {
        display: flex;
        flex-wrap: wrap;
    }

    .list-upload-image .input-thumbnail-item {
        width: 69px;
        height: 69px;
        border: 1px solid #d9d9d9;
        background: #fff;
        margin: 5px;
    }

    .list-upload-image .input-thumbnail-item img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .upload-pts-img {
        margin: 5px;
    }

    .list-upload-image {
        width: 100%;
    }

    .upload-pts-img {
        width: 69px;
        height: 69px;
        border: 1px solid #d9d9d9;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .icon-up {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #444;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .input-square {
        width: 117px;
        height: 117px;
        flex-shrink: 0;
        border: 1px solid #d9d9d9;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    span.upload-thumbnail {
        background: #676767;
        color: #fff;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 2px;
        font-size: 14px;
        padding: 7px 14px;
        outline: none !important;
        font-family: "Nunito Sans", sans-serif;
    }

    .list-product-tab-item {
        display: flex;
        margin: 10px 0;
    }

    .list-product-tab-item span {
        display: flex;
        align-items: center;
    }

    .list-product-tab-item span .icon {
        margin-left: 6px;
    }

    .file-type {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .file-type span {
        color: #676767;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 6px;
    }

    .thumbnail-avatar {
        width: 200px;
        height: 200px;
    }

    .thumbnail-avatar img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .card-box {
        border: 1px solid;
        padding: 10px;
        display: flex;
        flex-wrap: wrap;
    }

    .card-item {
        width: calc(33.33% - 20px);
        margin: 10px;
        display: flex;
        align-items: center;
    }

    .check-content label {
        margin: 0 0 0 10px !important;
    }
`;

const RemoveIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <path d="M7 1L1 7" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7 7L1 1" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};
